module.exports = __webpack_public_path__ + "static/media/step12.da7da952.png";